export default function Footer() {
  return (
    <footer className="border-t border-ti-border px-6 py-4">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-ti-text-dim">
        {/* Left: Built by */}
        <span>
          Built by{' '}
          <a
            href="https://tedvlango.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-ti-text-muted hover:text-ti-blue transition-colors duration-300"
          >
            Ted Lango
          </a>
        </span>

        {/* Center: Powered by */}
        <span>
          Powered by the{' '}
          <a
            href="https://living-resume-api.tedlango.workers.dev/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-ti-text-muted hover:text-ti-cyan transition-colors duration-300"
          >
            Living Resume API
          </a>
        </span>

        {/* Right: Book link */}
        <a
          href="https://www.amazon.com/dp/B0FZWDPH2M"
          target="_blank"
          rel="noopener noreferrer"
          className="text-ti-text-muted hover:text-ti-purple transition-colors duration-300"
        >
          Adaptive: Building Workforce Systems for an (Unpredictable) Future
        </a>
      </div>
    </footer>
  );
}
